<template lang="pug">
div
	page-header(:title='title', :url='url', :titleNew='titleNew')
	vue-element-loading(:active='isActive' spinner='bar-fade-scale' color='#428BCA')
	grid(ref="grid" :url='urlDataSource', :columns='columns', :height="400")
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import Grid from '@/components/Grid'

import GridTemplate from '@/mixins/GridTemplate'
import Permission from '@/mixins/Permission'

import { confirme, erro, sucesso } from '@/components/Message'
import req from '@/components/request'

export default {
	mixins: [GridTemplate, Permission],
	components: {
		VueElementLoading,
		PageHeader,
		Grid
	},
	data() {
		return {
			title: 'Páginas',
			titleNew: '',
			url: '/sistema/paginas/',
			urlDataSource: `${this.$url}/paginas?all`,
			columns: [{
				field: 'title',
				title: 'Título',
				width: 400
			}, {
				field: 'active_name',
				title: 'Ativo',
				width: 120
			}],
			isActive: false,
		}
	},
	methods: {
		verifPermissao() {
			this.titleNew = this.ACTION.c ? 'Novo' : ''
			if (this.ACTION.e || this.ACTION.d) {
				this.columns.push({
					field: 'ativo',
					title: 'Ações',
					width: 105,
					template: this.commandTemplate
				})
			}
		},
		async buttonClickApagar(item) {
			const result = await confirme(item.title,'Tem certeza que deseja remover esse registro? pois a exclusão é irreversível e não é possível voltar os dados')
			if(result.isConfirmed) {
				this.isActive = true
				await req(`/paginas/${item.id}`, 'delete').catch(() => {
					erro()
				})
				sucesso('Atualizado...')
				this.$refs.grid.$refs.datasource1.kendoDataSource.read()
			}
			this.isActive = false
		}
	},
	created() {
		this.verifPermissao()
	}
}
</script>

<style lang="stylus" scoped>

</style>
